'use strict';
import $ from 'jquery';

export default class ResourceArchive {
    static init() {
        new ResourceArchive();
    }

    constructor() {
        const self = this;

        $('.resource-filter-toggle, .resource-filter-popup .close-icon').on('click', function (e) {
            $('.resource-filter-popup').toggleClass('active');
        });

        if ($('[data-id="resources_library"], [data-id="blog_library"], [data-id="customer_stories_library"], [data-id="careers_blog_library_filters"]').length) {
            if ($('[data-id="careers_blog_library_filters"]').length === 0) {
                window.almOnChange = function (alm) {
                    $('.resource-filter-popup').removeClass('active');
                };
                // window.almOnPagingComplete = function (alm) {
                //   console.log('alm paging complete: ', alm);
                // };

            }
            window.almOnLoad = function (alm) {
                // $('.alm-filters--button').append('<div class="arrow arrow-orange"></div>');
            };
            window.almComplete = function (alm) {
                self.onAlmComplete(alm);
            };
            window.almOnPagingComplete = function (alm) {
                self.onAlmComplete(alm);
            };
        }
    }

    onAlmComplete(alm) {
        if (alm.ajax.dataset.taxonomy || alm.ajax.dataset.category) {
            let count = [];
            if (alm.ajax.dataset.taxonomy) {
                count.push(...alm.ajax.dataset.taxonomyTerms.split(/[:,]+/));
            }
            if (alm.ajax.dataset.category) {
                count.push(...alm.ajax.dataset.category.split(/[:,]+/));
            }
            $('.filter-count').html('(' + count.length + ')');
        } else {
            $('.filter-count').html('');
        }
        let resultCount = '';
        let startCount = 0;
        let endCount = 0;
        let totalposts = 0;

        // this is cached results
        let page = $('#resource-library-ajax-data').data('page');
        startCount = (page - 1) * alm.posts_per_page + 1;
        totalposts = $('#resource-library-ajax-data').data('total-posts');
        endCount = page * $('#resource-library-ajax-data').data('posts-per-page');
        if (endCount > totalposts) endCount = totalposts;
        // resultCount = 'Showing ' + startCount + ' to ' + endCount + ' of ' + $('#resource-library-ajax-data').data('total-posts');

        resultCount = '';
        if (totalposts > 0) {
            resultCount = 'Showing ' + startCount + ' to ' + endCount + ' of ' + totalposts;
            $('.alm-results-text').hide();
        } else {
            $('.alm-results-text').show();
        }
        const $div = $('<div>');
        $div.addClass('small resource-result-count');
        $div.html(resultCount);
        $('.resource-result-count').remove();
        $('.alm-btn-wrap').prepend($div);
        $('.resource-filter-showing').empty().append($div.clone());
    }
}
